module.exports = "./img/f5050ddca294c7cfcae2ea0a6c7a8346.jpg";